import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const AccessControl = ({ roles, children, fallback }) => {
  const userProfile = useSelector((e) => e.profile.userProfile);
  const userRole = userProfile?.type || "";
  const hasAccess = roles.includes(userRole);
  return hasAccess ? children : fallback;
};

AccessControl.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  fallback: PropTypes.node,
};

export default AccessControl;
